import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "entity" }
const _hoisted_2 = { class: "topic-icon" }
const _hoisted_3 = ["title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TableHead = _resolveComponent("TableHead")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Column = _resolveComponent("Column")
  const _component_TrackerBase = _resolveComponent("TrackerBase")

  return (_openBlock(), _createBlock(_component_TrackerBase, { widget: $props.widget }, {
    default: _withCtx(() => [
      _createVNode(_component_Column, { field: "entity.name" }, {
        header: _withCtx(() => [
          _createVNode(_component_TableHead, { name: "Topic" })
        ]),
        body: _withCtx(({data: {entity}}) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Icon, {
                icon: "hash-02-a",
                size: "1.5rem",
                stroke: "var(--brand-700)",
                "stroke-width": "1"
              })
            ]),
            _createElementVNode("span", {
              class: "entity-name",
              title: entity.name
            }, _toDisplayString(entity.name), 9 /* TEXT, PROPS */, _hoisted_3)
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget"]))
}